/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListDoctorExtraSpecialtiesRequest = {
  properties: {
    professionalId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
